"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Banner = require("./Banner");
Object.keys(_Banner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Banner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Banner[key];
    }
  });
});